<app-company-fit [showNotes]="true">
  <app-action-icons></app-action-icons>
</app-company-fit>
